import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export const CountdownTimer = () => {
  // Start with 23:59:55 in seconds
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 55);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return {
      hours: h.toString().padStart(2, '0'),
      minutes: m.toString().padStart(2, '0'),
      seconds: s.toString().padStart(2, '0')
    };
  };
  const {
    hours,
    minutes,
    seconds
  } = formatTime(timeLeft);
  return <div className="bg-red-50 border border-red-100 rounded-xl md:rounded-2xl p-4 md:p-8 text-center max-w-2xl mx-auto shadow-sm" data-id="element-57">
      <div className="flex items-center justify-center gap-1.5 text-red-600 font-bold uppercase tracking-wider mb-3 text-xs md:text-base" data-id="element-58">
        <Clock className="w-4 h-4 md:w-5 md:h-5" data-id="element-59" />
        <span data-id="element-60">El precio de lanzamiento termina en:</span>
      </div>

      <div className="flex justify-center gap-2 md:gap-4 mb-4 md:mb-6" data-id="element-61">
        <div className="flex flex-col items-center" data-id="element-62">
          <div className="bg-white text-charcoal font-bold text-2xl md:text-5xl p-2.5 md:p-4 rounded-lg md:rounded-xl shadow-sm border border-gray-100 w-14 md:w-24" data-id="element-63">
            {hours}
          </div>
          <span className="text-[10px] md:text-xs text-gray-500 mt-1 uppercase font-semibold" data-id="element-64">
            Horas
          </span>
        </div>
        <div className="text-2xl md:text-5xl font-bold text-gray-300 mt-1 md:mt-2" data-id="element-65">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-66">
          <div className="bg-white text-charcoal font-bold text-2xl md:text-5xl p-2.5 md:p-4 rounded-lg md:rounded-xl shadow-sm border border-gray-100 w-14 md:w-24" data-id="element-67">
            {minutes}
          </div>
          <span className="text-[10px] md:text-xs text-gray-500 mt-1 uppercase font-semibold" data-id="element-68">
            Min
          </span>
        </div>
        <div className="text-2xl md:text-5xl font-bold text-gray-300 mt-1 md:mt-2" data-id="element-69">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-70">
          <div className="bg-white text-charcoal font-bold text-2xl md:text-5xl p-2.5 md:p-4 rounded-lg md:rounded-xl shadow-sm border border-gray-100 w-14 md:w-24" data-id="element-71">
            {seconds}
          </div>
          <span className="text-[10px] md:text-xs text-gray-500 mt-1 uppercase font-semibold" data-id="element-72">
            Seg
          </span>
        </div>
      </div>

      <p className="text-sm md:text-base text-gray-600 font-medium mb-4 md:mb-6" data-id="element-73">
        Después sube <span className="font-bold text-red-600" data-id="element-74">$8.000 ARS</span>{' '}
        y no vuelve a bajar.
      </p>

      <div className="bg-white rounded-full p-0.5 md:p-1 border border-gray-200 relative overflow-hidden h-5 md:h-6" data-id="element-75">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: '68%'
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} className="absolute top-0 left-0 h-full bg-red-500 rounded-full" data-id="element-76"></motion.div>
        <div className="absolute inset-0 flex items-center justify-center text-[10px] md:text-xs font-bold text-charcoal z-10" data-id="element-77">
          🔴 Cupos al precio de lanzamiento — 68% tomados
        </div>
      </div>
    </div>;
};